import React, { Component } from 'react';
import CalculatorForm from './components/calculatorForm.js';
import ResultsTable from './components/resultsTable.js';
import ErrorDisplay from './components/errorDisplay.js';

import './App.css';
import {
  APP_TITLE,
} from './constants/fragments.js';

import { setRatesData, getResults } from './calc.js';
import { makeGenericErrorMessage } from './constants/errorDisplay.js';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: null,
      isLoading: true, // start in loading state while we fetch rates.json
      salary: 0,
      errorHeading: null,
      noRateData: false,
      errors: []
    };
  }
  componentDidMount() {
    document.title = APP_TITLE;

    console.log(process.env.NODE_ENV)

    // default to local rates file for 'development' and 'test'
    let ratesURL = './rates.json';

    // check custom env var for 'qa'
    if (process.env.REACT_APP_JSON_SOURCE === 'qa') {
      ratesURL = 'https://qa.web-cdn.ucop.edu/tcc/rates.json';
    } else if (process.env.NODE_ENV === 'production') {
      ratesURL = 'https://web-cdn.ucop.edu/tcc/rates.json';
    }

    fetch(ratesURL).then(rates => rates.json())
      .then(rates => {
        setRatesData(rates);
        this.setState({ isLoading: false });
      }).catch(error => {
        this.setState({
          noRateData: true,
          isLoading: false,
          errors: [ makeGenericErrorMessage({ error: error.message }) ]
        });
      })
  }

  handleSubmit = formOptions => {
    try {
      const results = getResults(formOptions);
      this.setState({
        results,
        salary: formOptions.salary,
        errors: []
      });
    } catch (e) {
      this.setState({
        errors: [ makeGenericErrorMessage({ error: e.message }) ]
      })

    }

  }

  setErrors = (errorHeading, errors) => {
    this.setState({
      errorHeading,
      errors
    })
  };

  render() {
    const {
      errorHeading,
      errors,
      results,
      isLoading,
      salary,
      noRateData
    } = this.state;

    return (
      <div className="App">
        <div className={'blur-screen ' + (isLoading ? 'loading' : '')} />
        {
          Boolean(errors.length) &&
            <ErrorDisplay
              errors={errors}
              heading={errorHeading}
              className ='control-group error show_error'
            />
        }
        <CalculatorForm
          onSubmit={this.handleSubmit}
          shouldLockForm={isLoading || noRateData}
          setErrors={this.setErrors}
        />
        { results && <ResultsTable results={results} salary={salary} /> }
      </div>
    )
  }
}

export default App;
